import type { EmptyStateHandler } from '@atlaskit/editor-common/types/empty-state-handler';
import type { QuickInsertOptions } from '@atlaskit/editor-common/types/quick-insert';
import type { QuickInsertPluginOptions } from '@atlaskit/editor-plugin-quick-insert/quick-insert-plugin-type';

interface Props {
	options: {
		emptyStateHandler?: EmptyStateHandler | undefined;
		/**
		 * Pages whose element list is fixed (topic pages) offer no insertion at all,
		 * so quick insert goes headless: no `/` typeahead and no element browser.
		 */
		isTemplateLocked?: boolean;
		quickInsert?: QuickInsertOptions;
	};
}

export function quickInsertPluginOptions({ options }: Props): QuickInsertPluginOptions {
	const isTemplateLocked = Boolean(options?.isTemplateLocked);

	return {
		enableElementBrowser: !isTemplateLocked,
		elementBrowserHelpUrl: '',
		disableDefaultItems: isTemplateLocked,
		headless: isTemplateLocked,
		emptyStateHandler: options?.emptyStateHandler,
		prioritySortingFn:
			typeof options.quickInsert === 'object' ? options.quickInsert.prioritySortingFn : undefined,
		onInsert: typeof options.quickInsert === 'object' ? options.quickInsert.onInsert : undefined,
	};
}
